var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "用户",
                            prop: "tuser.id",
                            rules: [
                              {
                                required: true,
                                message: "用户不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("user-select", {
                            attrs: { limit: 1, value: _vm.inputForm.tuser.id },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.tuser.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属部门",
                            prop: "office.id",
                            rules: [
                              {
                                required: true,
                                message: "所属部门不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "office",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/office/treeData?type=2",
                              value: _vm.inputForm.office.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.office.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属区域",
                            prop: "area.id",
                            rules: [
                              {
                                required: true,
                                message: "所属区域不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "area",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/area/treeData",
                              value: _vm.inputForm.area.id,
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.area.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "名称",
                            prop: "name",
                            rules: [
                              {
                                required: true,
                                message: "名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "性别",
                            prop: "sex",
                            rules: [
                              {
                                required: true,
                                message: "性别不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.inputForm.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "sex", $$v)
                                },
                                expression: "inputForm.sex",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList("sex"),
                              function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.value,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "身份证照片",
                            prop: "file",
                            rules: [],
                          },
                        },
                        [
                          _c("image-upload", {
                            attrs: {
                              limit: 3,
                              tip: "最多上传3个图片,单个图片不要超过10M",
                            },
                            model: {
                              value: _vm.inputForm.file,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "file", $$v)
                              },
                              expression: "inputForm.file",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "加入日期",
                            prop: "inDate",
                            rules: [],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "选择日期时间",
                            },
                            model: {
                              value: _vm.inputForm.inDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "inDate", $$v)
                              },
                              expression: "inputForm.inDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-tabs",
                            {
                              model: {
                                value: _vm.testDataMainFormTab,
                                callback: function ($$v) {
                                  _vm.testDataMainFormTab = $$v
                                },
                                expression: "testDataMainFormTab",
                              },
                            },
                            [
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "汽车票" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.addTestDataChild23Row },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "table",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        data: _vm.inputForm.testDataChild23DTOList.filter(
                                          function (item) {
                                            return item.delFlag !== "1"
                                          }
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "startArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "startArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.startArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.startArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "endArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "目的地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "endArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.endArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.endArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.startTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "startTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.startTime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "到达时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.endTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "endTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.endTime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "代理价格",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "请填写代理价格",
                                                  },
                                                  model: {
                                                    value: row.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.price",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "备注信息",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "请填写备注信息",
                                                  },
                                                  model: {
                                                    value: row.remarks,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "remarks",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.remarks",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delTestDataChild23Row(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "火车票" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.addTestDataChild21Row },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "table",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        data: _vm.inputForm.testDataChild21DTOList.filter(
                                          function (item) {
                                            return item.delFlag !== "1"
                                          }
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "startArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "startArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.startArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.startArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "endArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "目的地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "endArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.endArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.endArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.starttime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "starttime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.starttime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "到达时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.endtime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "endtime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.endtime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "代理价格",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "请填写代理价格",
                                                  },
                                                  model: {
                                                    value: row.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.price",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "文件",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("file-upload", {
                                                  attrs: {
                                                    limit: 3,
                                                    tip: "最多上传3个文件,单个文件不要超过10M",
                                                  },
                                                  model: {
                                                    value: row.t1File,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "t1File",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.t1File",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "备注信息",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "请填写备注信息",
                                                  },
                                                  model: {
                                                    value: row.remarks,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "remarks",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.remarks",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delTestDataChild21Row(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "飞机票" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.addTestDataChild22Row },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "table",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        data: _vm.inputForm.testDataChild22DTOList.filter(
                                          function (item) {
                                            return item.delFlag !== "1"
                                          }
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "startArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "startArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.startArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.startArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "endArea.name",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "目的地",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("SelectTree", {
                                                  ref: "endArea",
                                                  attrs: {
                                                    props: {
                                                      value: "id", // ID字段名
                                                      label: "name", // 显示名称
                                                      children: "children", // 子级字段名
                                                    },
                                                    url: "/sys/area/treeData",
                                                    value: row.endArea.id,
                                                    clearable: true,
                                                    accordion: true,
                                                  },
                                                  on: {
                                                    getValue: function (value) {
                                                      row.endArea.id = value
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "出发时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.startTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "startTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.startTime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "到达时间",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetime",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                    placeholder: "选择日期时间",
                                                  },
                                                  model: {
                                                    value: row.endTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "endTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.endTime",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "代理价格",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "请填写代理价格",
                                                  },
                                                  model: {
                                                    value: row.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.price",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "",
                                          "header-align": "center",
                                          align: "center",
                                          "show-overflow-tooltip": "",
                                          label: "备注信息",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "请填写备注信息",
                                                  },
                                                  model: {
                                                    value: row.remarks,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "remarks",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.remarks",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          width: "100",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delTestDataChild22Row(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }